<template>
  <div>
    <div>
      <div class="hidden md:grid justify-items-center grid-rows-1 grid-flow-col gap-4 bg-background-thirdary text-white">
        <div class="pl-4 py-8">
          <nav-white-logo />
          <ul class="pt-4">
            <li>
              <a
                class="px-2 leading-loose text-sm flex items-center text-white hover:opacity-75"
                href="tel:+18004339570"
              >
                <span><t-icon
                  name="mobile-alt"
                  class="text-white text-sm"
                  style="cursor: pointer;" /><b class="text-white"> Tel:</b> (800) 433-9570</span>
              </a>
            </li>
            <li>
              <a
                class="px-2 leading-loose text-sm flex items-center text-white hover:opacity-75"
                href="fax:(615)376-8233"
              >
                <span><t-icon
                  name="print"
                  class="text-white text-sm"
                  style="cursor: pointer;" /><b class="text-white"> Fax:</b>  (615) 376-8233</span>
              </a>
            </li>
            <li>
              <nuxt-link
                to="/support"
                target="_blank"
                class="px-2 leading-loose text-sm flex items-center text-white hover:opacity-75">
                <span><t-icon
                  name="clock"
                  class="text-white text-sm"
                  style="cursor: pointer;" /> <b class="text-white">Customer Service & Help</b><br /> 7AM-6PM Central, Mon-Fri</span>
              </nuxt-link>
            </li>
            <li>
              <a
                href="mailto:customerservice@summit-education.com"
                target="_blank"
                class="px-2 leading-loose text-sm flex items-center text-white hover:opacity-75">
                <span><t-icon
                  name="envelope"
                  class="text-white text-sm"
                  style="cursor: pointer;" /> <b>Email Us</b></span>
              </a>
            </li>
            <li>
              <a
                href="https://d2vu1vyohnm3g3.cloudfront.net/documents/spe-attendee-registration-form.pdf"
                target="_blank"
                class="px-2 leading-loose text-sm flex items-center text-white hover:opacity-75">
                <b>Printable Registration Form</b>
              </a>
            </li>
            <li class="px-2">
              <a
                href="https://www.facebook.com/summitprofessionaleducation/"
                target="_blank">
                <t-icon
                  :name="['fab', 'facebook-square']"
                  class="text-white inline-block mr-1"
                  style="cursor: pointer;" />
              </a>
              <a
                href="https://www.youtube.com/user/summitproed"
                target="_blank">
                <t-icon
                  :name="['fab', 'youtube']"
                  class="text-white inline-block mr-1"
                  style="cursor: pointer;" />
              </a>
              <a
                href="https://www.instagram.com/summitprofessionaleducation"
                target="_blank">
                <t-icon
                  :name="['fab', 'instagram']"
                  class="text-white inline-block mr-1"
                  style="cursor: pointer;" />
              </a>
              <a
                href="https://www.linkedin.com/company/summit-professional-education"
                target="_blank">
                <t-icon
                  :name="['fab', 'linkedin-in']"
                  class="text-white inline-block mr-1"
                  style="cursor: pointer;" />
              </a>
              <a
                href="https://r4j68.app.goo.gl/?link=https%3A%2F%2Fsummit-pt-ot-connection.podbean.com%3Faction%3DopenPodcast%26podcastId%3Dpbblog16521108%26podcastIdTag%3Dzzmub&dfl=https%3A%2F%2Fsummit-pt-ot-connection.podbean.com&utm_campaign=pb_web&utm_source=podbean_web&utm_medium=dlink&imv=670&amv=530&isi=973361050&ibi=com.podbean.app.podcast&ipbi=com.podbean.app.podcast&apn=com.podbean.app.podcast"
                target="_blank">
                <img
                  src="https://fastfs1.podbean.com/site/images/badges/w600_1.png"
                  alt="app download"
                  style="width: 100px;
              height: 36px;
              border: none;"
                /></a>
            </li>
          </ul>
        </div>
        <div class="py-8">
          <div>
            <h5 class="font-bold leading-loose text-white">
              Courses
            </h5>
            <nuxt-link to="/profession">
              <label class="font-bold text-base cursor-pointer">By Profession</label>
            </nuxt-link>
            <div
              v-for="(course, id) in navItems.course.professions"
              :key="id">
              <a
                :href="course.link"
                role="menuitem"
              >
                <button
                  class="block px-4 py-2 text-sm leading-5 text-white transition duration-150 ease-in-out hover:bg-bg-primary-140 focus:outline-none focus:bg-primary-120"
                >
                  {{ course.title }}
                </button>
              </a>
            </div>
            <div class="pt-2">
              <nuxt-link to="/certification-series">
                <label class="font-bold text-base cursor-pointer">Certification Series</label>
              </nuxt-link>
            </div>
            <div class="pt-2">
              <nuxt-link to="/signature-series/stroke-symposium/nashville-july-2025">
                <label class="font-bold text-base cursor-pointer">Stroke Symposium 2025</label>
              </nuxt-link>
            </div>
            <!--            <div class="pt-2">-->
            <!--              <nuxt-link to="/ce-acceleration-virtual-conference">-->
            <!--                <label class="font-bold text-base cursor-pointer"> 2024 CE Webathon</label>-->
            <!--              </nuxt-link>-->
            <!--            </div>-->
          </div>
        </div>
        <div class="py-8">
          <div>
            <label class="font-bold"><nuxt-link to="/topics">Topics</nuxt-link></label>
            <div
              v-for="(course, id) in navItems.course.topics"
              :key="id"
              class="">
              <a
                :href="course.link"
                role="menuitem"
              >
                <button
                  class="block px-4 py-2 text-sm leading-5 text-white transition duration-150 ease-in-out hover:bg-primary-120 focus:outline-none focus:bg-primary-120"
                >
                  {{ course.title }}
                </button>
              </a>
            </div>
          </div>
        </div>
        <div class="py-8">
          <div>
            <label class="font-bold"><nuxt-link to="/formats">Formats</nuxt-link></label>
            <div
              v-for="(course, id) in navItems.course.formats"
              :key="id"
              class="">
              <a
                :href="course.link"
                role="menuitem"
              >
                <button
                  class="block px-4 py-2 text-sm leading-5 text-white transition duration-150 ease-in-out hover:bg-primary-120 focus:outline-none focus:bg-primary-120"
                >
                  {{ course.title }}
                </button>
              </a>
            </div>
          </div>
        </div>
        <div class="py-8">
          <ul class="text-xl font-bold leading-loose">
            <li class="text-white">
              <nuxt-link to="/subscription/subscription-v2">
                Subscriptions
              </nuxt-link>
            </li>
            <li class="text-white">
              <nuxt-link to="/group-sales">
                Group Sales
              </nuxt-link>
            </li>
            <li class="text-white">
              <nuxt-link to="/live-ce-course-states">
                CE Requirements by State
              </nuxt-link>
            </li>
            <li class="text-white">
              <nuxt-link to="/about">
                About
              </nuxt-link>
            </li>
            <li class="text-white">
              <a
                href="https://support.summit-education.com/hc/en-us/categories/201682343-General"
                target="_blank">
                FAQs
              </a>
            </li>
            <li class="text-white">
              <nuxt-link to="/reviews">
                Reviews & Testimonials
              </nuxt-link>
            </li>
            <li class="text-white">
              <nuxt-link to="/instructor/directory">
                Instructors
              </nuxt-link>
            </li>
            <li class="text-white">
              <a
                href="https://summit-education.com/blog/"
                target="_blank">
                Instructor Blogs
              </a>
            </li>
            <li class="text-white">
              <a
                href="https://summit-education.com/blog/join/"
                target="_blank">
                Join Our Faculty
              </a>
            </li>
            <li class="text-white">
              <a
                href="https://app.monstercampaigns.com/c/rsyjmmiae38taepi7fqs/"
                target="_blank">
                Site Feedback
              </a>
            </li>
          </ul>
        </div>
        <div class="bg-background-primary w-full grid justify-items-center">
          <t-signup-form
            :source="'footer'"
          >
            <template #title>
              <h4 class="leading-loose text-white">
                Sign Up for Special Offers
              </h4>
              <p class="text-white">
                Be the first to know about new courses and special promotions!
              </p>
            </template>
          </t-signup-form>
        </div>
      </div>
      <div class="md:hidden grid grid-row-2 grid-cols-1">
        <div class="bg-background-fourth px-3">
          <t-signup-form
            :source="'footer'"
          >
            <template #title>
              <h4 class="leading-loose text-white">
                Sign Up for Special Offers
              </h4>
            </template>
          </t-signup-form>
        </div>
        <div class="bg-background-thirdary p-6">
          <a
            href="tel:+18004339570"
            class="block py-4 text-base text-white hover:opacity-75">
            Tel:(800) 433-9570
          </a>
          <nuxt-link
            to="/"
            class="block py-4 text-base items-center text-white hover:opacity-75">
            Fax: (615) 376-8233
          </nuxt-link>
          <nuxt-link
            to="/support"
            target="_blank"
            class="block py-4 text-base items-center text-white hover:opacity-75">
            Customer Service & Help<br /> 7AM-6PM Central, Mon-Fri
          </nuxt-link>
          <a
            href="mailto:customerservice@summit-education.com"
            target="_blank"
            class="block py-4 text-base items-center text-white hover:opacity-75">
            Email Us
          </a>
          <div>
            <a
              href="https://r4j68.app.goo.gl/?link=https%3A%2F%2Fsummit-pt-ot-connection.podbean.com%3Faction%3DopenPodcast%26podcastId%3Dpbblog16521108%26podcastIdTag%3Dzzmub&dfl=https%3A%2F%2Fsummit-pt-ot-connection.podbean.com&utm_campaign=pb_web&utm_source=podbean_web&utm_medium=dlink&imv=670&amv=530&isi=973361050&ibi=com.podbean.app.podcast&ipbi=com.podbean.app.podcast&apn=com.podbean.app.podcast"
              target="_blank">
              <img
                class="py-4"
                src="https://fastfs1.podbean.com/site/images/badges/w600_1.png"
                alt="app download"
                style="width: 150px;
              border: none;"
              /></a>
            <div class="flex justify-between items-center py-4">
              <a
                href="https://www.facebook.com/summitprofessionaleducation/"
                target="_blank">
                <t-icon
                  :name="['fab', 'facebook-square']"
                  class="text-white text-4xl"
                  style="cursor: pointer;" />
              </a>
              <a
                href="https://www.instagram.com/summitprofessionaleducation"
                target="_blank">
                <t-icon
                  :name="['fab', 'instagram']"
                  class="text-white text-4xl"
                  style="cursor: pointer;" />
              </a>
              <a
                href="https://www.linkedin.com/company/summit-professional-education"
                target="_blank">
                <t-icon
                  :name="['fab', 'linkedin-in']"
                  class="text-white text-4xl"
                  style="cursor: pointer;" />
              </a>
              <a
                href="https://www.youtube.com/user/summitproed"
                target="_blank">
                <t-icon
                  :name="['fab', 'youtube']"
                  class="text-white text-4xl"
                  style="cursor: pointer;" />
              </a>
            </div>
          </div>
          <t-container class="py-4 text-left">
            <p class="text-sm text-white">
              Copyright &copy; {{ new Date().getFullYear() }} Summit Professional Education, LLC. All Rights Reserved. | <nuxt-link
                class="text-sm text-white"
                to="/about/privacy-policy">
                Privacy Policy
              </nuxt-link> | <nuxt-link
                class="text-sm text-white"
                to="/subscription/tc">
                Subscription Terms
              </nuxt-link> | <a
                class="text-sm text-white"
                href="https://d2vu1vyohnm3g3.cloudfront.net/documents/summit-w9.pdf"
                target="_blank">
                Summit W-9
              </a>
            </p>
          </t-container>
        </div>
      </div>
    </div>
    <t-container class="hidden md:block py-6 text-center">
      <p class="text-xs">
        Copyright &copy; {{ new Date().getFullYear() }} Summit Professional Education, LLC. All Rights Reserved. | <nuxt-link
          class="text-xs no-underline"
          to="/about/privacy-policy">
          Privacy Policy
        </nuxt-link> | <nuxt-link
          class="text-xs no-underline"
          to="/subscription/tc">
          Subscription Terms
        </nuxt-link> | <a
          class="text-xs no-underline"
          href="https://d2vu1vyohnm3g3.cloudfront.net/documents/summit-w9.pdf"
          target="_blank">
          Summit W-9
        </a>
      </p>
    </t-container>
  </div>
</template>

<script>
import { mapActions, } from 'pinia';
import { useSearchStore, } from '../../stores/search';
import navItems from '@/data/navigationItems.json';

export default {
  name: 'FooterInfo',
  data() {
    return {
      navItems,
    };
  },
  methods: {
    ...mapActions(useSearchStore, ['applyFilters']),
  },
};
</script>
